<template>
  <div>
    <K8MClusterMetricCards :clusterMetricsData="metricsCardsData" />
    <K8MClusterUsageGraphs :clusterUsageData="getForecastChartConfig" />
    <K8MClusterTables />
  </div>
</template>

<script>
import K8MClusterTables from '@/components/K8M/Cluster/ClusterTable.vue';
import K8MClusterMetricCards from '@/components/K8M/Cluster/ClusterMetricCards.vue';
import K8MClusterUsageGraphs from '@/components/K8M/Cluster/ClusterUsageGraphs.vue';
import { mapMutations, mapGetters, mapState } from 'vuex';
import { K8_NAVTABS } from '@/utils/templates/k8mTemplate/k8m.constants';
import { K8BreadcrumbNames } from '@/components/K8M/k8.types';
import {
  clusterMetricsData,
  clusterUsageForecastGraphs,
  clusterUsageAOGraphs,
} from '@/components/K8M/Cluster/cluster.card.config';

export default {
  components: {
    K8MClusterTables,
    K8MClusterMetricCards,
    K8MClusterUsageGraphs,
  },
  name: 'K8MClusterOverview',
  data() {
    return {
      metricsCardsData: clusterMetricsData(),
    };
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('k8State/k8CommonState', ['currentCluster']),
    ...mapState('globalState/app', ['isForcastEnabled']),
    getForecastChartConfig() {
      return clusterUsageAOGraphs().map((obj, index) =>
        this.isForcastEnabled && obj.isForecast
          ? clusterUsageForecastGraphs[index]
          : obj,
      );
    },
  },
  methods: {
    ...mapMutations('globalState/app', ['setUpdateDasboard']),
    ...mapMutations('k8State/k8CommonState', [
      'setCurrentRouteConfig',
      'setCurrentK8Tab',
    ]),
  },
  watch: {
    'currentCluster.key'() {
      this.setUpdateDasboard(this.currentCluster);
    },
  },
  created() {
    this.clusterUsageAOGraphs = clusterUsageAOGraphs;
    this.clusterUsageForecastGraphs = clusterUsageForecastGraphs;
  },
  mounted() {
    this.setCurrentK8Tab(K8_NAVTABS.K8M_CLUSTER_TAB);
    this.setCurrentRouteConfig([
      {
        name: 'k8mCluster',
        path: 'clusterOverview',
        breadcrumbName: K8BreadcrumbNames.cluster,
        tab: K8_NAVTABS.K8M_CLUSTER_TAB,
      },
    ]);
  },
};
</script>
